export default __webpack_public_path__ + "static/media/icono2.8381dbce.svg";